import { apiClient } from "../config";

async function addExistingAdmis(data: any) {
  const res = await apiClient.post(`/admin/communities/members`, data);
  return res.data;
}

export default addExistingAdmis;
